export default "__VITE_ASSET__DckSM$Jp__"